import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-950">
                大师兄影视
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              第一时间更新最新上映电影、热播电视剧、综艺节目，更新快抢先看，高清免费在线观看不卡顿。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">首页</Link>
              <Link to="/category" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">全部分类</Link>
              <Link to="/category?type=movie" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">电影</Link>
              <Link to="/category?type=drama" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">电视剧</Link>
              <Link to="/category?type=variety" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">综艺</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              关于我们
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">用户口碑</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">联系我们</Link>
              <span className="text-sm text-foreground-500">contact@dashixiong.tv</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {["流浪地球3", "封神", "哪吒", "庆余年", "三体", "繁花", "奔跑吧", "科幻", "动画"].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs rounded-full bg-background-200 text-foreground-600 cursor-pointer hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 大师兄影视. 本站所有内容均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">关注我们</span>
            <div className="flex items-center gap-2">
              <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-xs"></i>
              </a>
              <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-xs"></i>
              </a>
              <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}